export const HAS_SEEN_LUX_Q2_VR_OFFER_MODAL_KEY =
  "HAS_SEEN_LUX_Q2_VR_OFFER_MODAL_KEY";
